<template>
    <div class="signature-component">

        

        <canvas id="signature-pad" class="signature-pad is-block" width="600" height="150">
        </canvas>
        
        <div class="signature-pad-footer is-inline-block mt-3 mr-5" v-if="footer">{{ footer }}</div>

        <b-button @click="clearSignature" class="is-inline-block mt-3 is-size-7 signature-pad-clear">Clear signature</b-button>        

        <b-input 
            type="hidden"
            id="signature-data"
            :required="required"
            v-bind:value="value">
        </b-input>
    </div>
</template>

<script>

import SignaturePad from 'signature_pad' 

export default {
    name: 'Signature',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
            signaturePad: Object,
        }
    },
    methods: {
        clearSignature () {
            console.log('clear signature')
            this.signaturePad.clear()
            this.setValue('')
        },
        setValue (value) {
            console.log('set value: ' + value)
            this.$emit('input', value)
        }
    },
    mounted(){
        var canvas = document.getElementById("signature-pad")

        console.log(canvas)
        console.log(this.value)

        var self = this

        let signaturePad = new SignaturePad(canvas, {
            onEnd: function () {

                // Signature data as png
                var data = signaturePad.toDataURL('image/png')

                // Set the input value
                var input = document.getElementById("signature-data").value = data
                
                self.setValue(data)
                //self.$emit('input', data)
            }
        });

        signaturePad.fromDataURL(this.value, {ratio: 1})

        this.signaturePad = signaturePad
        
    },     
    computed: {
        footer () {
            return this.component.footer ?? null
        },
    }
}

</script>

<style>

.signature-pad {
    width: 600px;
    height: 150px;
    background-color: #ddd;
    border-radius: 10px;
}
</style>

